import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  const input = "w-full bg-black border border-zinc-800 px-4 py-3 text-white placeholder-zinc-600 focus:border-tib-amber focus:outline-none transition-colors";

  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <img src="/tib-logo.png" alt="TIB" className="w-9 h-9 object-contain" />
          <span className="font-mono text-sm tracking-widest uppercase text-white">TIB Console</span>
        </div>
        <div className="card-edge p-8">
          <h1 className="h-serif text-2xl text-white mb-6">Admin sign in</h1>
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="admin-email" type="email" required placeholder="Email" className={input} value={email} onChange={(e) => setEmail(e.target.value)} />
            <input data-testid="admin-password" type="password" required placeholder="Password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} />
            {error && <p className="text-red-400 text-sm" data-testid="admin-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-submit" className="btn-primary w-full justify-center disabled:opacity-60">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
